import React from "react";

import classes from "./styles.module.scss";

const NoData = ({ text = "There is no data available for these selected models." }) => {
    return (
        <div className={classes.noDataContainer}>
            <div className={classes.backdrop} />
            <div className={classes.textContainer}>
                <p>{text}</p>
            </div>
        </div>
    );
};

export default NoData;
